import React from 'react';
import { useState, useEffect, useMemo } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Add, Assignment, Code, Create, PictureAsPdf, Restore, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';

import { WithApp } from 'contexts/appContext';
import { Box, Tooltip } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import CardIcon from 'components/Card/CardIcon';
import Badge from 'components/Badge/Badge';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import columns from '../headerTableList';
import { wsGet } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import PdfModal from 'components/Tvendo/Common/PdfModal';
import { useModal } from 'hooks/useModal';
import ModalUpdateGuide from './ModalUpdateGuide';
import { wsUpdate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '500'
  }
});

export default WithApp(function Product(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [shopping, setShopping] = useState([]);

  //modal para editar guias
  const [guide, setGuide] = useState(false);
  const [model, setOpen] = useModal();

  const { title, originType, excelName, permission } = props;
  const [valueSearch, setValueSearch] = useState({});
  const [file, setFile] = useState({ open: false });

  async function listInvoices(filter) {
    let response = await wsFindBy('purch/purchase', { ...filter, origin: originType });
    if (response.success) setShopping(response.data);
  }

  async function getDocument(idDoc, type) {
    let response = await wsGet(`purch/purchase/${idDoc}/${type}`);
    if (response.success) {
      setFile({ data: response.data, open: true });
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function restoreError(buy) {
    let res = await wsUpdate(`purch/purchase/${buy.id}/remove-error`);
    if (res.success) {
      listInvoices({ ...valueSearch });
    }
    window.alert(res.message);
  }

  function filterColumns() {
    let dataColumns = columns;
    if (originType === 'P') {
      dataColumns = columns.filter((item) => !item.accessor.includes(['WhsName']));
    }
    return dataColumns;
  }

  useEffect(() => {
    // IsGuide no va para facturas proveedor
    let search = { ...valueSearch };
    if(originType !== 'P'){
      search.is_guide = guide ? 'Y' : 'N';
    }
    if (Object.keys(valueSearch).length > 0) {
      listInvoices({ ...valueSearch });
    }
  }, [valueSearch, guide]);

  const [pdfId, setPdfId] = useState();
  const pdfSrc = useMemo(() => {
    if(pdfId === undefined) return;
    let entity = `purch/provider-invoice`;
    return `${entity}/${pdfId}/pdf`;
  }, [pdfId]);

  return (
    <>
      <Toasty action={notify} />
      <ModalFull
        title="Documento de compra"
        open={file.open}
        setOpen={() => setFile({ open: false })}
        iframe
      >
        <iframe src={file.data} width="100%" height="100%" className="text">
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>

      <PdfModal open={pdfId !== undefined} onClose={() => setPdfId(undefined)} src={pdfSrc} />

      <ModalBase
        title="Actualizar a fatura"
        model={{ open: model.open, id: model.id }}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => listInvoices({ ...valueSearch, is_guide: guide ? 'Y' : 'N' })}
        entity="purch/purchase/update-guide"
      >
        <ModalUpdateGuide guide={model} />
      </ModalBase>

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={permission.store}
            component={
              <CardIcon color="primary">
                <Assignment style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to={`0?type=${originType}`}>
              <CardIcon color="success" pointer="true">
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>
          <div className={classes.cardIconTitle}>
            <span>{title}</span>
            <div>
              <Button onClick={() => setGuide(!guide)} size="sm" color={guide ? 'info' : 'github'}>
                Listar {guide ? 'facturas' : 'guías'}
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <FilterCustom getFilter={setValueSearch} dateRange zone stateMultiple />

          <ReactTable
            formatDate="DD-MM-YYYY"
            excelName={excelName}
            defaultWidth={4700}
            columns={filterColumns()}
            data={shopping.map((buy, i) => {
              let color = 'success';
              let status = '';
              switch (buy.proc_status) {
                case 'D':
                  status = 'Borrador';
                  break;
                case 'V':
                  status = 'Validado';
                  break;
                case 'C':
                  status = 'Confirmado';
                  break;
                case 'X':
                  status = 'En espera';
                  break;
                case 'R':
                  status = 'Recibido';
                  break;
                case 'A':
                  status = 'Anulado';
                  break;
                case 'Y':
                  status = 'Preparado';
                  break;
                case 'T':
                  status = 'Contabilizado';
                  break;
                case 'Z':
                  status = 'Para NC - compra';
                  break;
                default:
                  status = 'NC registrada';
                  break;
              }
              let hasError = false;
              if (buy.proc_status === 'X' && buy.error_message.length > 2) {
                hasError = true;
                color = 'danger';
                status = 'Error!';
              }

              return {
                num: (
                  <Box>
                    {i + 1}
                    <AllowedGuard permission={permission.update}>
                      {originType !== 'P' && (
                        <>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorDanger}
                            onClick={() => getDocument(buy.id, 'pdf')}
                          >
                            <PictureAsPdf />
                          </Button>

                          <Button
                            justIcon
                            round
                            simple
                            color="info"
                            onClick={() => getDocument(buy.id, 'xml')}
                          >
                            <Code />
                          </Button>
                        </>
                      )}

                      {originType === 'P' && (
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorDanger}
                          onClick={() => setPdfId(buy.id)}
                        >
                          <PictureAsPdf />
                        </Button>
                      )}

                      <Button justIcon round simple color={props.themeContext.buttonColor}>
                        <Link to={`${buy.id}?type=${originType}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                    {buy.is_guide === 'Y' ? (
                      <AllowedGuard permission={permission.update}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(buy)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                    ) : undefined}
                  </Box>
                ),
                proc_status: hasError ? (
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Tooltip title={buy.error_message}>
                      <div>
                        <Badge color={color} className={classes.total}>
                          {status}
                        </Badge>
                      </div>
                    </Tooltip>
                    <Button
                      size="sm"
                      color="danger"
                      justIcon
                      simple
                      round
                      onClick={() => restoreError(buy)}
                    >
                      <Restore />
                    </Button>
                  </div>
                ) : (
                  <Badge color={color} className={classes.total}>
                    {status}
                  </Badge>
                ),
                base_zone_description: buy.base_zone_description,
                WhsName: buy.WhsName,
                GroupNum: buy.PymntGroup,
                tax_date: buy.tax_date,
                CardCode: buy.CardCode,
                cardName: buy.CardName,
                LicTradNum: buy.LicTradNum,
                is_guide: buy.is_guide === 'Y' ? 'Si' : 'No',
                ReceiptType: buy.document_type_description,
                ReceiptSerie: buy.ReceiptSerie,
                ReceiptNumber: buy.ReceiptNumber,
                op_gravada: buy.op_gravada,
                op_inafecta: buy.op_inafecta,
                op_exonerada: buy.op_exonerada,
                VatSum: buy.VatSum,
                SumIsc: buy.SumIsc,
                SumOtTrib: buy.SumOtTrib,
                SumOtCarg: buy.SumOtCarg,
                total_discount: buy.total_discount,
                VatSumTotal: buy.VatSumTotal,
                DocTotal: buy.DocTotal,
                Currency: buy.Currency,
                DocDueDate: buy.DocDueDate,
                DiscPrcnt: parseFloat(buy.DiscPrcnt).toFixed(2) + '%',
                DiscSum: buy.DiscSum,
                doc_status: buy.doc_status == 'O' ? 'Abierto' : 'Cerrado',
                sum_free_transfer: buy.sum_free_transfer,
                sum_bonification: buy.sum_bonification,
                sum_igv: buy.sum_igv,
                created_at: buy.created_at,
                updated_at: buy.updated_at,
                DocDate: buy.DocDate,
                last_process_date: buy.last_process_date,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
